import { useState } from "react";
import { Button, Modal, Select, Typography } from "antd";
import InfiniteScroll from 'react-infinite-scroll-component';

import './ModalLuckMachine.css';
import { formatTicketNumber } from "../../../../util/utils";

const { Title, Text } = Typography;
const { Option } = Select;

const bundles = [
    { tickets: 1, popular: false },
    { tickets: 2, popular: false },
    { tickets: 3, popular: false },
    { tickets: 5, popular: true },
    { tickets: 10, popular: false },
    { tickets: 20, popular: false },
    { tickets: 100, popular: false },
    // { tickets: 1000, popular: false },
];

export default function ModalLuckMachine(props) {
    const { visible, onClose, selectedTickets, data, mergeTicketsList } = props;
    const [ticketsAmount, setTicketsAmount] = useState(0);
    const [generatedTickets, setGeneratedTickets] = useState([]);


    const handleChange = value => {
        setTicketsAmount(value);
        setGeneratedTickets([]);
    };


    const generateTickets = () => {
        const availableTickets = data?.tickets.filter(ticket => !selectedTickets.some(sel => sel.ticketNumber === ticket.ticketNumber));

        const arr = [...availableTickets];
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }

        const randomTickets = arr.slice(0, ticketsAmount);
        setGeneratedTickets(randomTickets);
    };


    const onCancel = () => {
        onClose();
        setTicketsAmount(0);
        setGeneratedTickets([]);
    };


    const handleAddToSelectedTickets = () => {
        mergeTicketsList(generatedTickets);
        onCancel();
    };


    return (
        <Modal
            open={visible}
            onCancel={onCancel}
            footer={null}
            centered
            destroyOnHidden>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <Title level={3}>Máquina de la suerte</Title>
                <Title level={4} style={{ color: "#a63827" }}>Selecciona cuántos boletos deseas generar al azar</Title>
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                <Text style={{ minWidth: "130px" }} strong>Boletos a Generar:</Text>
                <Select
                    style={{ width: '100%', marginTop: "10px", marginBottom: "10px" }}
                    onChange={handleChange}
                    placeholder="Selecciona la cantidad de boletos"
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                >
                    {bundles.map((bundle) => (
                        <Option key={bundle.tickets} value={bundle.tickets}>{bundle.tickets} {bundle.tickets === 1 ? 'boleto' : 'boletos'} por ${data?.ticketPrice * bundle.tickets} MXN</Option>
                    ))}
                </Select>
                <Button disabled={ticketsAmount === 0} type="primary" className="luck-machine-generate-button" onClick={generateTickets} >Generar</Button>
            </div>
            <div id="scrollableDivGeneratedTickets" className="luck-machine-ticket-section">
                <InfiniteScroll
                    dataLength={generatedTickets.length}
                    scrollableTarget="scrollableDivGeneratedTickets"
                >
                    <div style={{ textAlign: "center", margin: "15px" }}>
                        <Text strong style={{ fontSize: "18px" }}>{generatedTickets.map(ticket => formatTicketNumber(ticket.ticketNumber, data?.ticketAmount)).join(", ")}</Text>
                    </div>
                </InfiniteScroll>
            </div>
            <div className="luck-machine-buttons-section">
                <Button disabled={generatedTickets.length === 0} className="luck-machine-generate-button" type="primary" size="large" onClick={handleAddToSelectedTickets}>Agregar a tu lista</Button>
            </div>
        </Modal>
    );
}